import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { SegmentedControl, Select, useLocalizeMessage, } from 'libs.nucleus';
export const EnvironmentSelector = ({ environments, selectedEnvironmentId, onChange, }) => {
    const translate = useLocalizeMessage();
    const [deploymentSegment, setDeploymentSegment] = useState('test');
    const segmentItems = useMemo(() => [
        { id: 'test', label: translate('Test') },
        { id: 'production', label: translate('Production') },
    ], [translate]);
    const activeSegmentIndex = deploymentSegment === 'test' ? 0 : 1;
    const filteredEnvironments = useMemo(() => {
        const list = environments ?? [];
        return list.filter((env) => (deploymentSegment === 'test' ? !env.isProd : env.isProd));
    }, [deploymentSegment, environments]);
    const environmentOptions = useMemo(() => {
        return filteredEnvironments.map((env) => ({
            value: String(env.id),
            label: env.name,
            meta: {
                environmentId: env.id,
            },
        }));
    }, [filteredEnvironments]);
    const selectedOption = useMemo(() => environmentOptions.find((option) => option.meta?.environmentId === selectedEnvironmentId), [environmentOptions, selectedEnvironmentId]);
    useEffect(() => {
        if (environmentOptions.length === 0) {
            if (selectedEnvironmentId !== undefined) {
                onChange(undefined);
            }
            return;
        }
        const isSelectionInFilteredList = environmentOptions.some((option) => option.meta?.environmentId === selectedEnvironmentId);
        if (isSelectionInFilteredList) {
            return;
        }
        const firstEnvironmentId = environmentOptions[0]?.meta?.environmentId;
        if (firstEnvironmentId !== undefined) {
            onChange(firstEnvironmentId);
        }
    }, [environmentOptions, onChange, selectedEnvironmentId]);
    const handleSegmentClick = useCallback((item) => {
        setDeploymentSegment(item.id);
    }, []);
    const handleSelectChange = useCallback((option) => {
        const id = option.meta?.environmentId;
        if (id !== undefined) {
            onChange(id);
        }
    }, [onChange]);
    const environmentSelectLabel = translate('Select environment to configure sites of:');
    const environmentSelectPlaceholder = useMemo(() => {
        if (environmentOptions.length > 0) {
            return translate('Choose an environment');
        }
        return deploymentSegment === 'test'
            ? translate('No test environments available')
            : translate('No production environments available');
    }, [deploymentSegment, environmentOptions.length, translate]);
    return (_jsxs("div", { className: 'nucleus-flex nucleus-shrink-0 nucleus-flex-row nucleus-items-center nucleus-gap-4', children: [_jsx(SegmentedControl, { activeItemIndex: activeSegmentIndex, items: segmentItems, onItemClick: handleSegmentClick }), _jsx(Select, { "aria-label": environmentSelectLabel, placeholder: environmentSelectPlaceholder, options: environmentOptions, value: selectedOption, onChange: handleSelectChange, width: 'sm', disabled: environmentOptions.length === 0, dataTestId: 'site-configuration-environment-select' })] }));
};
